import React, { useEffect, useState } from "react"
import { useParams, Link } from "react-router-dom"
import { getAPIBaseURL } from "../services/helpers"
import { getData } from "../services/request"
import { TicketIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline'

const VerifyEmail = () => {
  const { userId, token } = useParams()
  const [status, setStatus] = useState({ loading: true, success: false, message: "" })

  useEffect(() => {
    const verify = async () => {
      if (!userId || !token) {
        setStatus({ loading: false, success: false, message: "Invalid verification link" })
        return
      }

      try {
        const url = `${getAPIBaseURL()}/v1/users/verify-email/${userId}/${token}`
        const res = await getData(url, {}, {})

        if (res.error === "") {
          if (res.result.status === 200) {
            setStatus({ loading: false, success: true, message: res.result.data?.data || "Email verified successfully" })
          } else {
            setStatus({ loading: false, success: false, message: res.result.data?.message || "Verification failed" })
          }
        } else {
          setStatus({ loading: false, success: false, message: res.result?.data?.message || "Verification failed" })
        }
      } catch (error) {
        setStatus({ loading: false, success: false, message: "Network error. Please try again later." })
      }
    }

    verify()
  }, [userId, token])

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-slate-50">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex justify-center items-center gap-2 mb-6 group">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-600 to-cyan-500 text-white shadow-md transition-transform group-hover:scale-105">
            <TicketIcon className="h-6 w-6" />
          </div>
          <span className="text-2xl font-bold text-slate-900">Obule</span>
        </Link>
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-slate-900">
          Email Verification
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white px-4 py-8 shadow-xl border border-slate-100 sm:rounded-2xl sm:px-10">
          <div className="flex flex-col items-center text-center">
            {status.loading ? (
              <div className="animate-pulse flex flex-col items-center">
                <div className="h-12 w-12 bg-slate-100 rounded-full mb-4"></div>
                <p className="text-slate-500">Verifying your email address...</p>
              </div>
            ) : status.success ? (
              <div className="flex flex-col items-center">
                <CheckCircleIcon className="h-16 w-16 text-green-500 mb-4" />
                <h3 className="text-lg font-bold text-slate-900 mb-2">Verified!</h3>
                <p className="text-slate-600 mb-6">{status.message}</p>
                <Link
                  to="/login"
                  className="w-full justify-center rounded-full bg-cyan-600 px-8 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-cyan-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600 transition-all hover:scale-105"
                >
                  Proceed to Login
                </Link>
              </div>
            ) : (
              <div className="flex flex-col items-center">
                <XCircleIcon className="h-16 w-16 text-red-500 mb-4" />
                <h3 className="text-lg font-bold text-slate-900 mb-2">Verification Failed</h3>
                <p className="text-red-600 mb-6">{status.message}</p>
                <Link
                  to="/contact"
                  className="text-cyan-600 font-semibold hover:text-cyan-500"
                >
                  Contact Support
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyEmail
